import { render, staticRenderFns } from "./SpareInventoryList.vue?vue&type=template&id=83c147f4&scoped=true"
import script from "./SpareInventoryList.vue?vue&type=script&lang=js"
export * from "./SpareInventoryList.vue?vue&type=script&lang=js"
import style0 from "./SpareInventoryList.vue?vue&type=style&index=0&id=83c147f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c147f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83c147f4')) {
      api.createRecord('83c147f4', component.options)
    } else {
      api.reload('83c147f4', component.options)
    }
    module.hot.accept("./SpareInventoryList.vue?vue&type=template&id=83c147f4&scoped=true", function () {
      api.rerender('83c147f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/SpareInventoryList.vue"
export default component.exports